export const INCREMENT = "INCREMENT";
export const DECREMENT = "DECREMENT";
export const setFULL = "setFULL";
export const RESETBAR = "RESETBAR";
